// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.layout-logo[data-v-940f9c1c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.layout-logo img[data-v-940f9c1c] {\n  height: 29px;\n}\n.layout-logo--small img[data-v-940f9c1c] {\n  height: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
